import styled from 'styled-components';
import { devices } from '../../../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 500px;
  @media ${devices.phoneL} {
    width: 100%;
  }
`;

export const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 150px;
  align-items: center;
  margin-bottom: 5px;
  gap: 5px;
  & > div {
    min-width: 0;
  }
  & > *:first-child:only-child {
    grid-column: span 2;
  }
  & .textAreaContainer {
    box-sizing: border-box;
    min-height: 100px;
  }
`;

export const Info = styled.span`
  font-size: 12px;
  margin-bottom: 2px;
  & b {
    color: ${({ theme }) => theme.error};
    margin: 0;
  }
`;

export const InstructionsWrapper = styled(InputWrapper)`
  background-color: ${({ theme }) => theme.container};
  padding: 5px;
  border-radius: 8px;
`;

export const GPTCredits = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.grey};
  margin: 0 .5rem;
  & a {
    color: ${({ theme }) => theme.grey};
  }
  @media ${devices.phoneS} {
    font-size: 10px;
  }
`;

export const Label = styled.label`
  margin-left: auto;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.grey};
  font-weight: bold;
`;
